import { useV2ListQuestionsForQuestionnaireQuery } from "@generated";
import type { IndexQuestion } from "../types";

export const useSelectOptionQuestions = (questionnaireId: string) => {
  const { data, isLoading } = useV2ListQuestionsForQuestionnaireQuery(
    {
      questionnaireId: Number(questionnaireId),
      filter: { active: true },
      page: { size: 500 },
    },
    { refetchOnMountOrArgChange: true }
  );

  const questions: IndexQuestion[] = (data?.data ?? [])
    .map((q: any) => ({
      slug: q.attributes?.slug ?? "",
      name: q.attributes?.name ?? q.attributes?.question ?? "",
      options: (q.attributes?.["select-options"] ?? []).map((o: any) => ({
        key: o.key ?? "",
        value: o.value ?? "",
      })),
    }))
    .filter((q: IndexQuestion) => q.slug !== "" && q.options.length > 0);

  return { questions, isLoading };
};

export default useSelectOptionQuestions;
